import router from './router';
import {} from '@/utils/common';
const loginURL = process.env.LOGIN_PING;

router.beforeEach((to, from, next) => {
    let code = window.location.search > '' ? window.location.search.split('?')[1].split('=')[1] : '';

   /* if (!code > '' && !sessionStorage.getItem('token') > '') {
        window.location.href = loginURL
        return;
    }*/
    if (to.path === '/planCenter/planList' && !sessionStorage.getItem('token') > '') {
        if (code > '') {
            next({
                path: '/login',
                query: {
                    code
                }
            })
        }
    } else {
        next();
    }
});



// WEBPACK FOOTER //
// ./src/permission.js